import React, { useState } from "react";
import {
    Col,
    Form,
    FormControl,
    InputGroup,
    Modal,
    Button,
} from "react-bootstrap";
import { Send } from "react-bootstrap-icons";
import { Controller } from "react-hook-form";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import IconButton from "components/common/IconButton";
import { SearchPatientByID } from "features/eliglibility/eliglibility-check/config/eligibilityCheckApi";
import { handleResetPatientSearch } from "features/eliglibility/eliglibility-check/config/eligibilityCheckSlice";
import NoDetailsModal from "components/common/NoDetailsModal";

const IdentifierInput = ({
    control,
    watch,
    nationalityList,
    populateForm,
    reset,
}) => {
    const dispatch = useDispatch();
    const [showModal, setShowModal] = useState(false);
    const [pendingData, setPendingData] = useState(null);
    const [showNoDataModal, setShowNoDataModal] = useState(false);
    const handleSearchPatientByID = async () => {
        const id = watch("id") || "";
        const idType = watch("id_type");
        const firstChar = id.charAt(0);

        if (!id) {
            toast.error("Please enter ID or Iqama No.");
            return;
        }

        // if (idType === 1 || idType === "1") {
        //     if (!["1", "2"].includes(firstChar)) {
        //         toast.error("ID or Iqama No must start with 1 or 2");
        //         return;
        //     }
        //     if (id.length !== 10) {
        //         toast.error("ID or Iqama No must be 10 digits");
        //         return;
        //     }
        // } else if (idType !== 1 || idType !== "1") {
        //     if (["1", "2"].includes(firstChar)) {
        //         toast.error("Identifer and Id not matched");
        //         return;
        //     }
        //     if (id.length !== 10) {
        //         toast.error("Id must be 10 digits");
        //         return;
        //     }
        // }

        const response = await dispatch(
            SearchPatientByID({
                patient_natid: id,
                ntnlid_type: idType,
            })
        ).unwrap();

        if (response?.success) {
            if (
                response?.data?.cchi_message ===
                "CCHi Not Connected, Data retrived from old Details"
            ) {
                dispatch(handleResetPatientSearch());
                reset();
                setPendingData(response.data.patientsearch_data);
                setShowModal(true);
            } else if (response?.data?.length === 0) {
                reset();
                setShowNoDataModal(true);
            }
        } else {
            toast.error("Something went wrong");
        }
    };

    return (
        <>
            <Col xs={12} md={6}>
                <label className="form-label">
                    Identifier ID <span className="text-danger">*</span>
                </label>
                <InputGroup>
                    {/* ID Type Select */}
                    <Controller
                        name="id_type"
                        control={control}
                        rules={{ required: true }}
                        render={({ field }) => (
                            <Form.Select
                                {...field}
                                size="sm"
                                aria-label="Select ID Type"
                                value={watch("id_type")}
                            >
                                {nationalityList?.map((item) => (
                                    <option
                                        key={item.nationalid_type_id}
                                        value={item.nationalid_type_id}
                                    >
                                        {item.nationalid_type_disp_name}
                                    </option>
                                ))}
                            </Form.Select>
                        )}
                    />

                    {/* ID Input */}
                    <Controller
                        name="id"
                        control={control}
                        rules={{ required: "ID is required" }}
                        render={({ field, fieldState: { error } }) => {
                            const idType = watch("id_type");
                            const isNumericId =
                                watch("id_type") == 1 ||
                                watch("identifier_type")?.ident_type_code == "prc" || watch("identifier_type")?.ident_type_code == "ni";

                            // Define placeholder based on id_type
                            const getPlaceholder = (idType) => {
                                switch (Number(idType)) {
                                    case 1: // National & Residents
                                        return "ID / Iqama No.";
                                    case 2: // Visitors
                                        return "Visa / Passport / Border No.";
                                    case 4: // Tourists
                                        return "Visa / Passport No.";
                                    case 5: // Premium Residency
                                        return "Passport";
                                    case 6: // Hajj & Umrah Visitors
                                        return "Visa / Passport No.";
                                    default:
                                        return "ID / Iqama No.";
                                }
                            };

                            return (
                                <FormControl
                                    {...field}
                                    isInvalid={!!error}
                                    placeholder={getPlaceholder(idType)}
                                    size="sm"
                                    style={{ borderColor: error ? "red" : undefined }}
                                    // type={isNumericId ? "number" : "text"}
                                    onChange={(e) => {
                                        let value = e.target.value;

                                        // if (isNumericId) {
                                        // Allow only digits and limit to 10 characters
                                        // const numericValue = value
                                        //     .replace(/[^0-9]/g, "")
                                        //     .slice(0, 10);
                                        // field.onChange(numericValue);
                                        // } else {
                                        field.onChange(value);
                                        // }
                                    }}
                                // inputMode={isNumericId ? "numeric" : "text"}
                                // pattern={isNumericId ? "[0-9]*" : undefined}
                                // maxLength={isNumericId ? 10 : undefined}
                                />
                            );
                        }}
                    />

                    {/* Search Button */}
                    <IconButton size="sm" type="button" onClick={handleSearchPatientByID}>
                        <Send />
                    </IconButton>
                </InputGroup>
            </Col>

            <Modal show={showModal} centered>
                <Modal.Body className="text-center p-4">
                    <p className="mb-0 text-warning fw-bold">
                        No Details Returned from CHI - Do you want to use the details from
                        patient file history?
                    </p>
                </Modal.Body>
                <Modal.Footer className="justify-content-center border-0 pb-4">
                    <Button
                        variant="danger"
                        size="sm"
                        className="px-4"
                        onClick={() => setShowModal(false)}
                    >
                        No
                    </Button>
                    <Button
                        variant="success"
                        size="sm"
                        className="px-4"
                        onClick={() => {
                            populateForm(pendingData);
                            setShowModal(false);
                        }}
                    >
                        Yes
                    </Button>
                </Modal.Footer>
            </Modal>

            <NoDetailsModal showNoDataModal={showNoDataModal} setShowNoDataModal={setShowNoDataModal} />

        </>
    );
};

export default IdentifierInput;
